export const types = {
  LOGOUT: 'LOGOUT',
  FORCE_LOGOUT: 'FORCE_LOGOUT',
};

export const actions = {
  logout: () => ({ type: types.LOGOUT }),
  forceLogout: errorCode => ({
    type: types.FORCE_LOGOUT,
    payload: {
      errorCode,
    },
  }),
};

const initialState = {
  token: '',
  deviceID: '',
  headers: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOGOUT:
      return {
        ...initialState,
      };
    case types.FORCE_LOGOUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
export const getDeviceId = state => state.auth.deviceID;
export const getHeaders = state => state.auth.headers;
export const getToken = state => state.auth.token;



// WEBPACK FOOTER //
// ./app/redux/auth.js